import { generatePath } from "react-router-dom";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";
import { BenefitsSectionSlug } from "./data/sections";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const PATH_BENEFITS = "/member/benefits";

export const PARAMETER_SECTION = "section";
export const PARAMETER_TAB = "tab";
export const PARAMETER_SLUG = "slug";
export const PARAMETER_BENEFIT = "benefit";

// Section list routes. The URL segments double as the section slugs in
// `data/sections.tsx`, so the nav links below stay valid.
export const PATH_BENEFITS_SECTION = `${PATH_BENEFITS}/:${PARAMETER_SECTION}`;
export const PATH_BENEFITS_SECTION_TAB = `${PATH_BENEFITS_SECTION}/:${PARAMETER_TAB}`;

export const PATH_BENEFITS_PERKS = `${PATH_BENEFITS}/my-benefits`;
export const PATH_BENEFITS_INSURANCE = `${PATH_BENEFITS}/insurance`;
export const PATH_BENEFITS_AXIS_INSURANCE = `${PATH_BENEFITS}/axis-insurance`;

/**
 * Detail pages are addressed by slug alone — slugs are unique across the whole
 * catalog, so a benefit no longer has to be reached through the list it
 * happened to be rendered in.
 */
export const PATH_BENEFITS_DETAIL = `${PATH_BENEFITS}/detail/:${PARAMETER_SLUG}`;

export const routeHelpersBenefitsSection = createRouteHelpers<{
  section: BenefitsSectionSlug;
}>(PATH_BENEFITS_SECTION);

export const routeHelpersBenefitsSectionTab = createRouteHelpers<{
  section: BenefitsSectionSlug;
  tab: string;
}>(PATH_BENEFITS_SECTION_TAB);

export const routeHelpersBenefitDetail = createRouteHelpers<
  { slug: string },
  { state: { backPath?: string } }
>(PATH_BENEFITS_DETAIL);

// Legacy detail URLs, redirected to PATH_BENEFITS_DETAIL.
export const PATH_BENEFITS_LEGACY_SECTION_DETAIL = `${PATH_BENEFITS_SECTION_TAB}/:${PARAMETER_BENEFIT}`;
export const PATH_BENEFITS_LEGACY_AXIS_DETAIL = `${PATH_BENEFITS_AXIS_INSURANCE}/:${PARAMETER_BENEFIT}`;
export const PATH_BENEFITS_PERKS_PREVIEW = `${PATH_BENEFITS_PERKS}/dashboard`;
export const PATH_BENEFITS_LEGACY_PERKS_PREVIEW_DETAIL = `${PATH_BENEFITS_PERKS_PREVIEW}/:${PARAMETER_BENEFIT}`;

// Enrollment flows — unchanged.
export const PATH_BENEFITS_INSURANCE_ENROLL = `${PATH_BENEFITS}/insurance-enroll`;
export const PATH_BENEFITS_INSURANCE_ENROLL_FLOW = `${PATH_BENEFITS_INSURANCE_ENROLL}/:slug`;

export const PATH_BENEFITS_MERIDIO_EXPLORE_PLANS = `${PATH_BENEFITS_INSURANCE}/meridio/explore-plans`;
export const PATH_BENEFITS_MERIDIO_ENROLL = `${PATH_BENEFITS}/meridio-enroll`;
export const PATH_BENEFITS_MERIDIO_ENROLL_SELECT_PLANS = `${PATH_BENEFITS_MERIDIO_ENROLL}/select-plans/plans`;
export const PATH_BENEFITS_MERIDIO_ENROLL_SETUP_PAYMENT = `${PATH_BENEFITS_MERIDIO_ENROLL}/setup-payment`;

export const getBenefitsEnrollInsuranceFlowPathname = (slug: IPlanType) =>
  generatePath(PATH_BENEFITS_INSURANCE_ENROLL_FLOW, { slug });
